import { SignUp } from "@stories/pages/Authenticate/SignUp";

export const SignUpView = () => {
  return <SignUp />;
};
